// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicFilterList,
  DefaultFilterListProps
} from "./plasmic/paziresh_24_search/PlasmicFilterList";
import { HTMLElementRefOf } from "@plasmicapp/react-web";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface FilterListProps extends Omit<DefaultFilterListProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultFilterListProps altogether and have
// total control over the props for your component.
export interface FilterListProps extends DefaultFilterListProps {}

function FilterList_(props: FilterListProps, ref: HTMLElementRefOf<"div">) {
  // Use PlasmicFilterList to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicFilterList are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all FilterListProps here, but feel free
  // to do whatever works for you.

  return <PlasmicFilterList root={{ ref }} {...props} />;
}

const FilterList = React.forwardRef(FilterList_);
export default FilterList;
